import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBQMtaC3xjb7_0AbvLtWZ9FPYg386vyL0c",
  authDomain: "hive-70e06.firebaseapp.com",
  projectId: "hive-70e06",
  storageBucket: "hive-70e06.appspot.com",
  messagingSenderId: "847252662263",
  appId: "1:847252662263:web:288b5ad3a5d44a363630f2",
  measurementId: "G-15CPHT7765",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
export const firestore = getFirestore(app);
// connectFirestoreEmulator(firestore, "localhost", 8080);

export const analytics = getAnalytics(app);

export const auth = getAuth(app);
// connectAuthEmulator(auth, "http://localhost:9099");
